import { setup } from 'xstate'

type Events = { type: 'START' } | { type: 'STOP' } | { type: 'EXPIRED' }

const timerMachineSetup = setup({
  types: { events: {} as Events },
  actions: {},
})

const inactive = timerMachineSetup.createStateConfig({ on: { START: { target: 'active' } } })

const active = timerMachineSetup.createStateConfig({
  on: {
    EXPIRED: { target: 'expired' },
    STOP: { target: 'inactive' },
  },
})

const expired = timerMachineSetup.createStateConfig({ on: { STOP: { target: 'inactive' } } })

export const timerMachine = timerMachineSetup.createMachine({
  id: 'timer',
  initial: 'inactive',
  states: {
    inactive,
    active,
    expired,
  },
})
